import reassignPatients, { pickMostOverloadedPatient } from "./reassignPatients"

/**
 * Computes patient reassignments when a new nurse is added (often with a later
 * start time than the existing floor).
 *
 * Iteratively pulls one patient at a time from the most-overloaded nurse onto
 * the new nurse, stopping when no nurse is overloaded relative to the floor
 * average (which now includes the new nurse).
 *
 * @param {Object} newNurse - the new nurse, must be present in schedule.nurseSchedule
 * @param {{patientSchedule, nurseSchedule, chairSchedule}} schedule
 * @param {Object} settings
 * @param {boolean} sandbox
 * @param {boolean} isTomorrowMode
 * @returns {Array<{patientId, newNurseId}>}
 */
const getAssignmentsForNurseAddition = (
	newNurse,
	schedule,
	settings,
	sandbox,
	isTomorrowMode
) => {
	const workingSchedule = schedule.patientSchedule.map(p => ({ ...p }))
	const allAssignments = []
	const lockedPatientIds = new Set()
	const safety = workingSchedule.length

	for (let i = 0; i < safety; i++) {
		const next = pickMostOverloadedPatient({
			schedule,
			workingSchedule,
			excludePatientIds: lockedPatientIds
		})
		if (!next) break

		const assignments = reassignPatients({
			patientsToMove: [next.patient],
			candidateNurses: [newNurse],
			schedule: { ...schedule, patientSchedule: workingSchedule },
			settings,
			sandbox,
			isTomorrowMode,
			allowBumping: false
		})

		lockedPatientIds.add(next.patient.patientId)

		if (assignments.length === 0) continue

		const a = assignments[0]
		allAssignments.push(a)
		const wp = workingSchedule.find(p => p.patientId === a.patientId)
		if (wp) wp.assignedNurse = a.newNurseId
	}

	return allAssignments
}

export default getAssignmentsForNurseAddition
